import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ArchiveOrderFulfillmentMutationVariables = Types.Exact<{
  order_fulfillment_id: Types.Scalars['ID'];
}>;


export type ArchiveOrderFulfillmentMutation = { __typename?: 'Mutation', archiveOrderFulfillment: boolean };


export const ArchiveOrderFulfillmentDocument = gql`
    mutation ArchiveOrderFulfillment($order_fulfillment_id: ID!) {
  archiveOrderFulfillment(order_fulfillment_id: $order_fulfillment_id)
}
    `;
export type ArchiveOrderFulfillmentMutationFn = Apollo.MutationFunction<ArchiveOrderFulfillmentMutation, ArchiveOrderFulfillmentMutationVariables>;

/**
 * __useArchiveOrderFulfillmentMutation__
 *
 * To run a mutation, you first call `useArchiveOrderFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOrderFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOrderFulfillmentMutation, { data, loading, error }] = useArchiveOrderFulfillmentMutation({
 *   variables: {
 *      order_fulfillment_id: // value for 'order_fulfillment_id'
 *   },
 * });
 */
export function useArchiveOrderFulfillmentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOrderFulfillmentMutation, ArchiveOrderFulfillmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOrderFulfillmentMutation, ArchiveOrderFulfillmentMutationVariables>(ArchiveOrderFulfillmentDocument, options);
      }
export type ArchiveOrderFulfillmentMutationHookResult = ReturnType<typeof useArchiveOrderFulfillmentMutation>;
export type ArchiveOrderFulfillmentMutationResult = Apollo.MutationResult<ArchiveOrderFulfillmentMutation>;
export type ArchiveOrderFulfillmentMutationOptions = Apollo.BaseMutationOptions<ArchiveOrderFulfillmentMutation, ArchiveOrderFulfillmentMutationVariables>;